import React, { useMemo, useState } from "react";
import { Card, CardBody, Tooltip } from "reactstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { getTomDisplayId, getTomId } from "../../../../toms/utils/tomIdentifiers";

const RecordsTableCard = ({
  t,
  title,
  tooltipText,
  data = [],
  type = "plain",
  isFetching = false,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const columns = useMemo(() => {
    const baseColumns = [
      {
        dataField: type === "tom" ? "displayId" : "id",
        text: t("ID"),
        sort: true,
        style: {
          whiteSpace: "nowrap",
          width: "100px",
        },
        headerStyle: {
          width: "100px",
        },
        ...(type === "tom" && {
          formatter: (cell, row) => (
            <Link
              className="text-primary"
              to={`/admin/data-protection/toms/${getTomId(row)}/details?tab=tom`}
            >
              {cell ?? getTomDisplayId(row)}
            </Link>
          ),
        }),
      },
      {
        dataField: "title",
        text: t("Title"),
        sort: true,
        formatter: (cell, row) => {
          if (type === "tom") {
            return (
              <Link
                className="text-dark"
                to={`/admin/data-protection/toms/${getTomId(row)}/details?tab=tom`}
              >
                {cell}
              </Link>
            );
          }

          return <span>{cell}</span>;
        },
        style: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
    ];

    return baseColumns;
  }, [t, type]);

  const paginationOptions = {
    hideSizePerPage: false,
    hidePageListOnlyOnePage: false,
    sizePerPage: 5,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: t("All"), value: data.length || 1 },
    ],
  };

  if (isFetching) {
    return (
      <div
        className="dt-field dt-skeleton"
        style={{ width: "100%", height: "300px" }}
      />
    );
  }

  return (
    <Card className="card_box_Shadow h-100">
      <CardBody>
        <h4 className="card-title mb-4">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>{title}</div>

            {tooltipText ? (
              <>
                <i
                  className="fa fa-info-circle"
                  aria-hidden="true"
                  id={`infoIcon-${title.replace(/\s+/g, "-")}`}
                />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpen}
                  target={`infoIcon-${title.replace(/\s+/g, "-")}`}
                  toggle={() => setTooltipOpen((prev) => !prev)}
                >
                  {tooltipText}
                </Tooltip>
              </>
            ) : null}
          </div>
        </h4>

        <div
          className="table-responsive"
          style={{ overflowX: "hidden", maxWidth: "100%" }}
        >
          <BootstrapTable
            keyField={type === "tom" ? "tom" : "id"}
            data={data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            noDataIndication={t("No records found.")}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default RecordsTableCard;
